import {
  Card,
  Heading,
  IconTick,
  List,
  Stack,
  Text,
} from 'braid-design-system';

import { getCheckoutProductInfo } from 'src/data/listing-products/freemium/checkout';
import type { ListingProduct } from 'src/generated/graphql';

interface ProductDetailsProps {
  product: ListingProduct;
}

const AccelerateExperimentProductDetails = ({
  product,
}: ProductDetailsProps) => {
  const productInfo = getCheckoutProductInfo(product);

  return (
    <Card data={{ testid: 'accelerate-experiment-product-details' }}>
      <Stack space="large" align="left">
        <Heading level="3">Purchase {productInfo.description}</Heading>
        <List
          size="large"
          space="large"
          type="icon"
          icon={<IconTick tone="positive" />}
        >
          {productInfo.features.map((feature) => (
            <Text key={feature}>{feature}</Text>
          ))}
        </List>
        <Text size="large" data={{ testid: 'generic-product-details-price' }}>
          ${product.cost / 100} + GST
        </Text>
      </Stack>
    </Card>
  );
};

export default AccelerateExperimentProductDetails;
